import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import EventsTableWrapper from './table/EventsTableWrapper';

export function EventsCard() {
  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Events</h3>
        </Col>
      </Row>
      <Row>
        <EventsTableWrapper />
      </Row>
    </Container>
  );
}
